import React, { useRef } from 'react'
import { Plus, Minus } from 'react-feather'

const getValue = (value: string | number) => {
  if (value === null || value === undefined || value === '' || value === 'px') {
    return ''
  }
  const parsed = parseInt(value.toString())
  return Number.isNaN(parsed) ? '' : parsed
}

interface NumberStepperProps {
  value: number | string
  setValue: (value: number | string) => void
  suffix?: string
  label?: string
  min?: number
  max?: number
  step?: number
  disabled?: boolean
  customizeUIClasses?: {
    label: string
    container?: string
  }
}

export const NumberStepper = ({
  value,
  setValue,
  suffix,
  label,
  min,
  max,
  step,
  disabled = false,
  customizeUIClasses
}: NumberStepperProps) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const handleSuffixClick = () => {
    inputRef.current?.focus()
  }

  return (
    <div
      className={`flex flex-col gap-2 text-sm font-medium w-[130px] ${customizeUIClasses?.container}`}
      data-track-id='number-stepper-container'
    >
      {label && <h2 className={`font-semibold ${customizeUIClasses?.label}`}>{label}</h2>}
      <div className='inline-flex items-center border border-gray-light rounded-lg p-2 w-fit !text-coal-dark '>
        <Minus
          size={16}
          className='cursor-pointer'
          onClick={() => {
            let newValue = Math.max(min || 0, parseInt(value.toString()) - (step || 1))
            if (newValue < 0) {
              newValue = 0
            }
            setValue(newValue)
          }}
        />
        <div className='flex items-center mx-4'>
          <input
            ref={inputRef}
            type='text'
            value={getValue(value)}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const parsed = parseInt(e.target.value) || 0
              const newValue = Math.min(max ?? 100, Math.max(min ?? 0, parsed))
              setValue(newValue)
            }}
            disabled={disabled}
            className='text-center focus:outline-none'
            style={{ width: `${Math.max(getValue(value).toString().length, 2)}ch` }}
          />

          {suffix && (
            <span onClick={handleSuffixClick} className='cursor-pointer'>
              {suffix}
            </span>
          )}
        </div>
        <Plus
          size={16}
          className='cursor-pointer'
          onClick={() => {
            setValue(Math.min(max || 100, parseInt(value.toString()) + (step || 1)))
          }}
        />
      </div>
    </div>
  )
}
